<script>
  import * as ackeeTracker from "ackee-tracker";

  import Wrapper from "./components/layout/wrapper.svelte";
  import { Router } from "svelte-router-spa";
  import { routes } from "./routes";
  import { theme } from "./stores/store";
  import { onMount } from "svelte";

  onMount(() => {
    ackeeTracker
      .create("https://ackee-lemon.vercel.app", {
        detailed: true,
        ignoreLocalhost: true,
        ignoreOwnVisits: true,
      })
      .record("bebffd19-f475-4384-9323-f91645b86786");
  });
</script>

{#if $theme === "dark"}
  <style lang="scss">
    body {
      background: $dark;
    }
  </style>
{:else}
  <style lang="scss">
    body {
      background: $light;
    }
  </style>
{/if}

<svelte:head>
  <link
    rel="icon"
    type="image/png"
    href="favicon.png"
  />
  <title>Retale.me - Beautiful Quotes to Share</title>
  <meta
    name="description"
    content="Random quotes, displayed beautifully, shared easily."
  />
  <link
    rel="preconnect"
    href="https://fonts.gstatic.com"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,700;1,400&display=swap"
    rel="stylesheet"
  />
  <script
    src="https://kit.fontawesome.com/41e1df4ff0.js"
    crossorigin="anonymous"
  ></script>
</svelte:head>

<div class="theme {$theme}">
  <Wrapper>
    <Router {routes} />
  </Wrapper>
</div>

<style global>
  @import "src/styles/globalStyles.scss";
  @import "src/styles/theme.scss";
  @import "src/styles/media.scss";
  @import "bulma/sass/utilities/_index";
  @import "bulma/sass/helpers/flexbox";
  @import "bulma/sass/helpers/visibility";
</style>
